window.addEventListener('DOMContentLoaded', () => {
  const scrollButton = document.getElementById('scrollButton')
  const mainVisual = document.getElementById('mainVisual')
  if (scrollButton) {
    scrollButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
  }
  if (scrollButton && mainVisual) {
    if (window.scrollY > mainVisual.clientHeight) {
      scrollButton.classList.add('active')
    }
    window.addEventListener('scroll', () => {
      if (window.scrollY > mainVisual?.clientHeight) {
        scrollButton.classList.add('active')
      } else {
        scrollButton.classList.remove('active')
      }
    })
  } else if (scrollButton) {
    scrollButton.classList.add('active')
  }
})
